import { render } from "./PrivacyPolicyModal.vue?vue&type=template&id=14154be1&scoped=true"
import script from "./PrivacyPolicyModal.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyModal.vue?vue&type=script&lang=js"

import "./PrivacyPolicyModal.vue?vue&type=style&index=0&id=14154be1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14154be1"]])

export default __exports__